import { Heading } from '@cinch-labs/design-system'
import {
  BaseComponent,
  SbBlokData,
  StoryblokImage,
  storyblokEditable,
} from '@cinch-nx/data-storyblok'
import './landing-hero.module.css'
import { Wrapper } from '@cinch-nx/shared-ui'
import Image from 'next/image'
import { StoryblokRenderer } from '../../../storyblok-renderer/storyblok-renderer'
import { storyblokComponents } from '../../../storyblok/storyblok-renderer-map'
import styles from './landing-hero.module.css'
import cx from 'classnames'

export interface LandingHeroProps extends BaseComponent {
  logo: StoryblokImage
  heading: string
  ctaButton: SbBlokData
  image: StoryblokImage
  classNames?: string[]
}

export interface DesktopLandingHeroProps extends LandingHeroProps {
  classNames?: string[]
}

export interface MobileLandingHeroProps extends LandingHeroProps {
  classNames?: string[]
}

interface HeroContentProps {
  logo: StoryblokImage
  heading: string
  ctaButton: SbBlokData
}

const HeroContent: React.FC<HeroContentProps> = ({
  logo,
  heading,
  ctaButton,
}) => (
  <div className={styles.brandContent}>
    <div className={styles.logoWrapper}>
      <Image
        src={logo.filename}
        alt={logo?.alt ?? 'heroLogo'}
        priority
        quality={100}
        layout="fill"
        objectFit="fill"
      />
    </div>
    <Heading element="h1" className={styles.heading}>
      {heading}
    </Heading>
    <StoryblokRenderer block={ctaButton} components={storyblokComponents} />
  </div>
)

const DesktopHero: React.FC<DesktopLandingHeroProps> = ({
  logo,
  heading,
  ctaButton,
  image,
  classNames,
}: DesktopLandingHeroProps) => (
  <div className={cx(styles.heroWrapper, classNames)}>
    <HeroContent logo={logo} heading={heading} ctaButton={ctaButton} />
    <div className={styles.imageWrapper}>
      <Image
        src={image.filename}
        alt={image.alt ?? 'heroImage'}
        className={styles.image}
        quality={100}
        priority
        fill={true}
        style={{
          objectFit: 'contain',
          objectPosition: 'center',
        }}
      />
    </div>
  </div>
)

const MobileHero: React.FC<MobileLandingHeroProps> = ({
  logo,
  heading,
  ctaButton,
  image,
  classNames,
}: MobileLandingHeroProps) => (
  <div className={cx(classNames)}>
    <HeroContent logo={logo} heading={heading} ctaButton={ctaButton} />
    <div className={styles.imageWrapper}>
      <Image
        src={image.filename}
        alt={image.alt ?? 'heroImage'}
        className={styles.image}
        priority
        quality={100}
        layout="fill"
        objectFit="contain"
      />
    </div>
  </div>
)

export const LandingHero: React.FC<LandingHeroProps> = (blok) => (
  <Wrapper
    {...storyblokEditable(blok)}
    isFluid
    className={{
      inner: styles.container,
    }}
  >
    <MobileHero {...blok} classNames={[styles.mobileHeroWrapper]} />
    <DesktopHero {...blok} classNames={[styles.desktopHeroWrapper]} />
  </Wrapper>
)
